import Cookies from 'js-cookie';
import i18n, { loadLanguageAsync, mapToI18nextCompatibleFormat } from '../i18n/i18n';

/**
 * Checks if language cookies are synced with backend preference
 */
const checkLanguageCookieSync = () => {
    const edcLanguage = Cookies.get('EDC-LANGUAGE') || 'en';

    // i18next stores some codes internally in a normalized form (e.g. 'pt-br' -> 'ptBr').
    // Compare against that normalized form so codes like 'pt-br' don't appear to be
    // perpetually out of sync, which would re-trigger a language reload on every poll
    // and cause the app to re-render continuously.
    const targetLanguage = mapToI18nextCompatibleFormat(edcLanguage);

    // Already on the desired language — nothing to do.
    if (i18n.language === targetLanguage) {
        return;
    }

    // Sync cookies to match the normalized backend preference
    Cookies.set('datahub-lang', targetLanguage);
    Cookies.set('i18next', targetLanguage);

    // Load new language since it differs from the current one
    loadLanguageAsync(edcLanguage)
        .then(() => {
            console.log(`Language successfully changed to ${edcLanguage}`);
        })
        .catch((error) => {
            console.error(`Failed to load language ${edcLanguage}:`, error);
        });
};

/**
 * Starts language cookie polling to detect backend changes
 * @returns cleanup function to stop polling
 */
export const startLanguagePolling = (): (() => void) => {
    // Check immediately on start

    // Start polling immediately
    checkLanguageCookieSync();

    // Set up polling every 2 seconds to detect backend changes
    const pollInterval = setInterval(checkLanguageCookieSync, 2000);

    // Stop polling after 1 minute (60,000 ms)
    const stopTimeout = setTimeout(() => {
        clearInterval(pollInterval);
    }, 60000);

    // Return cleanup function
    return () => {
        clearInterval(pollInterval);
        clearTimeout(stopTimeout);
    };
};
